
// // import React, { useEffect, useState } from 'react';
// // import axios from 'axios';
// // import '../Styles/SolidTicket.css';
// // import Swal from "sweetalert2";
// // import {jwtDecode} from "jwt-decode";

// // const SolidTicket = () => {
// //   const [bookings, setBookings] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [userId, setUserId] = useState(null);

// //  useEffect(() => {
// //   const tokenData = JSON.parse(localStorage.getItem("b2bAuthToken") || '{}');
// //   const Token = tokenData.token;
// //   const externalApiToken = tokenData.externalApiToken;

// //   if (!Token || !externalApiToken) {
// //     Swal.fire("Authentication failed", "Please log in again.", "error");
// //     return;
// //   }

// //   try {
// //     const decodedToken = jwtDecode(Token);
// //     const id = decodedToken.id || decodedToken.userId;
// //     if (!id) throw new Error("User ID missing in token");
// //     setUserId(id);
// //   } catch (err) {
// //     Swal.fire("Token Error", "Invalid or malformed agency token.", "error");
// //   }
// // }, []);


// //   useEffect(() => {
// //     if (!userId) return;

// //     const fetchBookings = async () => {
// //       try {
// //         const res = await axios.post(
// //           `https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.bo7ki6/det789bag/${userId}`
// //         );
// //         setBookings(Array.isArray(res.data.data) ? res.data.data : [res.data.data]);
// //       } catch (error) {
// //         console.error('Error fetching booking data:', error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchBookings();
// //   }, [userId]);

// //   return (
// //     <div className="solidticket-main">
// //       <div className="solidticket-container">
// //         <div>Show Entries 10</div>
// //         <div className="st-row">
// //           <input type="date" placeholder="From Date" />
// //           <input type="date" placeholder="To Date" />
// //           <input type="text" placeholder="Search..." />
// //           <button>Search</button>
// //           <button>Download</button>
// //         </div>
// //       </div>

// //       <div>
// //         <table>
// //           <thead>
// //             <tr>
// //               <th>#Ref no</th>
// //               <th>Passenger</th>
// //               <th>Entry Date</th>
// //               <th>Destination</th>
// //               <th>PNR</th>
// //               <th>Travel Date</th>
// //               <th>Time</th>
// //               <th>Airline</th>
// //               <th>QTY</th>
// //               <th>Price</th>
// //               <th>Amount</th>
// //               <th>Action</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {loading ? (
// //               <tr><td colSpan="12">Loading...</td></tr>
// //             ) : bookings.length === 0 ? (
// //               <tr><td colSpan="12">No bookings found.</td></tr>
// //             ) : (
// //               bookings.map((item, index) => (
// //                 <tr key={item._id}>
// //                   <td>{item.booking_id || index + 1}</td>
// //                   {/* <td>{item.passenger_details?.name || 'N/A'}</td> */}
// //                      <td>
// //   {item.passenger_details ? (
// //     Object.entries(item.passenger_details).map(([type, passengers]) =>
// //       passengers.map((passenger, index) => (
// //         <div key={`${type}-${index}`}>
// //           {type}: {passenger.Name}
// //         </div>
// //       ))
// //     )
// //   ) : (
// //     <div>N/A</div>
// //   )}</td>
// //                   <td>{item.booking_date}</td>
// //                   <td>{item.sector}</td>
// //                   <td>{item.pnr}</td>
// //                   <td>{item.departure_date}</td>
// //                   <td>{item.departure_time} - {item.arrival_time}</td>
// //                   <td>{item.airline}</td>
// //                   {/* <td>{item.passenger_details ? 1 : 0}</td> */}
// //                   <td>
// //   {item.passenger_details
// //     ? Object.values(item.passenger_details).reduce(
// //         (total, group) => total + group.length,
// //         0
// //       )
// //     : 0}
// // </td>
// //                  <td>₹{item.base_price}</td>
// //                   <td>₹{item.total_price}</td>
// //                   <td><button>View</button></td>
// //                 </tr>
// //               ))
// //             )}
// //           </tbody>
// //         </table>
// //       </div>
// //     </div>
// //   );
// // };

// // export default SolidTicket;

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../Styles/SolidTicket.css';
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import * as XLSX from 'xlsx';

const SolidTicket = () => {
  const [bookings, setBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 10;

  useEffect(() => {
    const tokenData = JSON.parse(localStorage.getItem("b2bAuthToken") || '{}');
    const Token = tokenData.token;
    const externalApiToken = tokenData.externalApiToken;

    if (!Token || !externalApiToken) {
      Swal.fire("Authentication failed", "Please log in again.", "error");
      return;
    }

    try {
      const decodedToken = jwtDecode(Token);
      const id = decodedToken.id || decodedToken.userId;
      if (!id) throw new Error("User ID missing in token");
      setUserId(id);
    } catch (err) {
      Swal.fire("Token Error", "Invalid or malformed agency token.", "error");
    }
  }, []);

  useEffect(() => {
    if (!userId) return;

    const fetchBookings = async () => {
      try {
        const res = await axios.post(
          `https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.bo7ki6/det789bag/${userId}`
        );
        const data = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
        const enriched = data.map(item => ({
          ...item,
          rawBookingDate: new Date(item.booking_date)
        }));
        setBookings(enriched);
        setFilteredBookings(enriched);
      } catch (error) {
        console.error('Error fetching booking data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, [userId]);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    if (isNaN(date)) return '-';
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handleFilter = () => {
    let filtered = [...bookings];

    if (fromDate) {
      const from = new Date(fromDate);
      filtered = filtered.filter(b => b.rawBookingDate >= from);
    }

    if (toDate) {
      const to = new Date(toDate);
      filtered = filtered.filter(b => b.rawBookingDate <= to);
    }

    if (searchTerm) {
      filtered = filtered.filter(b =>
        (b.booking_id && b.booking_id.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (b.sector && b.sector.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }

    setFilteredBookings(filtered);
    setCurrentPage(1);
  };

  const exportToExcel = () => {
    const worksheetData = filteredBookings.map(item => ({
      "Ref No": item.booking_id,
      "Passenger": Object.entries(item.passenger_details || {}).flatMap(([type, passengers]) => passengers.map(p => `${type}: ${p.Name}`)).join(', '),
      "Entry Date": formatDate(item.booking_date),
      "Destination": item.sector,
      "PNR": item.pnr,
      "Travel Date": item.departure_date,
      "Time": `${item.departure_time} - ${item.arrival_time}`,
      "Airline": item.airline,
      "QTY": item.passenger_details ? Object.values(item.passenger_details).reduce((total, group) => total + group.length, 0) : 0,
      "Price": item.base_price,
      "Amount": item.total_price
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");
    XLSX.writeFile(workbook, "Solid_Ticket_Bookings.xlsx");
  };

  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentEntries = filteredBookings.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredBookings.length / entriesPerPage);

  return (
    <div className="solidticket-main">
      <div className="solidticket-container">
        <div>Show Entries 10</div>
        <div className="st-row">
          <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
          <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
          <input type="text" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} placeholder="Search..." />
          <button onClick={handleFilter}>Search</button>
          <button onClick={exportToExcel}>Download</button>
        </div>
      </div>

      <div>
        <table>
          <thead>
            <tr>
              <th>#Ref no</th>
              <th>Passenger</th>
              <th>Entry Date</th>
              <th>Destination</th>
              <th>PNR</th>
              <th>Travel Date</th>
              <th>Time</th>
              <th>Airline</th>
              <th>QTY</th>
              <th>Price</th>
              <th>Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="12">Loading...</td></tr>
            ) : currentEntries.length === 0 ? (
              <tr><td colSpan="12">No bookings found.</td></tr>
            ) : (
              currentEntries.map((item, index) => (
                <tr key={item._id}>
                  <td>{item.booking_id || index + 1}</td>
                  <td>
                    {item.passenger_details ? (
                      Object.entries(item.passenger_details).map(([type, passengers]) =>
                        passengers.map((passenger, index) => (
                          <div key={`${type}-${index}`}>
                            {type}: {passenger.Name}
                          </div>
                        ))
                      )
                    ) : (
                      <div>N/A</div>
                    )}
                  </td>
                  <td>{formatDate(item.booking_date)}</td>
                  <td>{item.sector}</td>
                  <td>{item.pnr}</td>
                  <td>{item.departure_date}</td>
                  <td>{item.departure_time} - {item.arrival_time}</td>
                  <td>{item.airline}</td>
                  <td>{item.passenger_details ? Object.values(item.passenger_details).reduce((total, group) => total + group.length, 0) : 0}</td>
                  <td>₹{item.base_price}</td>
                  <td>₹{item.total_price}</td>
                  <td><button>View</button></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <div className="pagination">
          <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>Prev</button>
          <span> Page {currentPage} of {totalPages} </span>
          <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default SolidTicket;
